import { render, staticRenderFns } from "./suggestionSecondAudit.vue?vue&type=template&id=2b4fd15e"
import script from "./suggestionSecondAudit.vue?vue&type=script&lang=js"
export * from "./suggestionSecondAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4fd15e')) {
      api.createRecord('2b4fd15e', component.options)
    } else {
      api.reload('2b4fd15e', component.options)
    }
    module.hot.accept("./suggestionSecondAudit.vue?vue&type=template&id=2b4fd15e", function () {
      api.rerender('2b4fd15e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sug/suggestionSecondAudit.vue"
export default component.exports